// import $ from 'jquery';
// import _ from 'lodash';
// import 'slick-carousel'
import PostSlick from '../modules/post_carousel';

export default {
  init() {
    // console.log('common');
  },
  finalize() {
    PostSlick('.post-carousel .posts');
  },
};
